<template>
    <ideo-form-group :label="$t('[[[Link do strony]]]')" :invalid-feedback="form.$errors.first('settings.page')" :state="form.$errors.state('settings.page')" required>
        <edito-page-selector v-model="form.settings.page" :module="module" label="" :website="false" :preview="false" class="mb-0" />
    </ideo-form-group>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Emit, Prop, Watch } from '@/helpers/Decorators';
import { Option } from '@/helpers/Interfaces';
import { FormType } from '@/helpers/Form';
import { ValidatableComponent } from '@/components/cms';
import merge from 'lodash/merge';

interface FormSettings
{
    settings: any;
}

@Options({
    name: 'widget-account-settings'
})
export default class AccountSettings extends Vue implements ValidatableComponent
{
    @Prop() public modelValue!: any;

    public module: string = '';
    public defaults: any = {
        page: null,
    };

    public get form(): FormType<FormSettings>
    {
        return this.modelValue;
    }

    public async created(): Promise<void>
    {
        this.form.settings = merge(this.defaults, this.form.settings);
    }

    @Watch('form.settings', { deep: true })
    public onSettingsChanged(value: any): void
    {
        this.triggetModel();
    }

    @Emit('update:modelValue')
    public triggetModel(): any
    {
        return this.form;
    }

    public async validate(): Promise<void>
    {
        this.form.validate(schema => ({
            settings: schema.object({
                page: schema.string().nullable().required(this.$t('[[[Wybranie strony jest wymagane]]]'))
            })
        }));
    }
}
</script>
